module.exports = __webpack_public_path__ + "media/assets/img/flags/de-DE-0d87103784289fdbbf3f9f58434a2609.png";